// @ts-nocheck
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enFullTranslation from '../../public/locales/en/translation.json';

const SUPPORTED = ['en', 'fr', 'zh', 'uk', 'ru', 'es', 'de', 'lt', 'da', 'nl', 'ko', 'ja'];
// Bump when shipped locale JSON changes so returning visitors skip stale assets.
export const LOCALE_ASSET_VERSION = 'observatory-fr-1.0.2';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED,
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation'],
    partialBundledLanguages: true,
    // The full EN namespace ships in the bundle (the same bytes the old
    // /locales/en/translation.json fetch used to move over the network): the
    // first paint no longer waits on that request and the strings can never
    // "top up" differently afterwards, which would re-render the hydrated
    // tree. Other languages still load through the HTTP backend exactly as
    // before.
    resources: {
      en: { translation: enFullTranslation },
    },
    detection: {
      // Only read from localStorage; never auto-write (handled manually via persistLanguage)
      order: ['localStorage'],
      lookupLocalStorage: 'ac_lang',
      caches: [],
      convertDetectedLanguage: (lng) => {
        if (typeof lng !== 'string') return 'en';
        return lng.split(/[-_]/)[0].toLowerCase();
      },
    },
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${LOCALE_ASSET_VERSION}`,
    },
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

/** Write language to localStorage only if cookie consent is accepted. */
export function persistLanguage(lang) {
  if (localStorage.getItem('ac_cookie_consent') === 'accepted') {
    localStorage.setItem('ac_lang', lang);
  }
}

/** Returns the browser's preferred language if it is in the supported list, else null. */
export function detectBrowserLanguage() {
  const raw = navigator.language || navigator.languages?.[0] || '';
  const code = raw.split('-')[0].toLowerCase();
  if (SUPPORTED.includes(code) && code !== 'en') return code;
  return null;
}

export { SUPPORTED };
